import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Signin = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [userNameTouched, setUserNameTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const isUserNameValid = userName.length > 0;
  const isPasswordValid = password.length > 0;
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/auth/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userName,
          password,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();  // Parse the error message
        throw new Error(errorData.message || 'Sign-in failed');
      }

      const data = await response.json();
      localStorage.setItem('token', data.access_token); // Store token in localStorage
      localStorage.setItem('name', data.name);
      localStorage.setItem('userId', data.userId)
      setLoading(false);
      navigate('/'); // Redirect after successful login
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div
      className="bg-cover bg-center w-full h-[100dvh] flex justify-center items-center"
      style={{ backgroundImage: `url('/building_background.png')` }}
    >
      <div className="signin-container font-alatsi shadow-custom-shadow-dark">
        <div className='signin-container-header'>
          <h3 className='font-medium text-xl'>Welcome to</h3>
          <h3 className='font-medium text-xl'>Rental Room Management System</h3>
          <h4 className='font-normal text-lg font-inter text-center mt-5'>Please Login</h4>
        </div>
        <form onSubmit={handleSubmit} className='signin-form'>
          <div
            className={`input-group ${
              !isUserNameValid && userNameTouched && 'invalid'
            } `}
          >
            <input
              type="text"
              id='userName'
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              onBlur={() => setUserNameTouched(true)}
              required
              className={`${
                !setUserName && setUserNameTouched && 'error-border'
              }`}
            />
            <label htmlFor='userName' className='font-medium'>Username *</label>
            {!isUserNameValid && userNameTouched && (
              <p className="error-text">Please enter a valid username</p>
            )}
          </div>
          <div
            className={`input-group ${
              !isPasswordValid && passwordTouched && 'invalid'
            }`}
          >
              <input
                type={'password'}
                id='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => setPasswordTouched(true)}
                required
                className={`${
                  !isPasswordValid && passwordTouched && 'error-border'
                }`}
              />
              <label htmlFor='password' className='font-medium'>Password *</label>
              {!isPasswordValid && passwordTouched && (
              <p className="error-text">Please enter password</p>
            )}
            </div>
          {error && <p className="error-message font-medium">{error}</p>}
          <button
            type="submit"
            disabled={!isUserNameValid || !isPasswordValid || loading}
            className="submit-btn"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Signin;
